import { Grid, Link, styled } from '@mui/material';

export const PrintsTableContainer = styled(Grid)(({ theme }) => ({
  '& table': {
    borderCollapse: 'collapse'
  },
  '& tr': {
    border: 'none !important',
    borderBottom: `1px solid ${theme.palette.grey[300]} !important`,
    paddingBlock: theme.spacing(1)
  },
  '& th, td': {
    paddingBlock: theme.spacing(1.5)
  },
  '& th': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'start',
    color: theme.palette.primary.main,
    paddingLeft: theme.spacing(1.5)
  }
}));

export const PrintLink = styled(Link)(({ theme }) => ({
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeightBold
  }
}));
